<footer class="jmlFooter">
  <p class="powered-by-text">powered by</p>
  <img src="assets/images/JMeleon_Logo_2021.png" class="footer-img" />
  <i class="fa fa-copyright copyright-icon" (click)="uploadLicense()"></i>
  <p class="copyright-text">&nbsp;{{ currentYear }}</p>
</footer>
